export const environment = {
  production: false,
  name: 'demo',
  projectName: 'RUBi',
  defaultTheme: 'RUBi',
  version: '1.1.0',
  region: 'us-gov-west-1',
  url: 'https://rubi-demo.gembotcloud.com',
  endpoint: 'https://rubi-be-project-demo.gembotcloud.com',
  sandboxEnabled: false,
  uamUrl: 'https://uam-demo.gembotcloud.com/',
  refreshEndpoint: 'https://demo-be.gembotcloud.com/auth/refreshToken',
  boardsEnabled: false,
  cookieInfo: {
    domain: '.gembotcloud.com',
  }
};
